import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const PrivateRoute = ({ component: Component, auth, ...rest }) => {
  const location = useLocation();
  return (
    <Route
      {...rest}
      render={props => {
        if (auth.isLoading) {
          return (
            <div className="load">
              <div className="load__icon-wrap">
                <svg className="load__icon">
                  <path
                    fill="#4ce1b6"
                    d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
                  />
                </svg>
              </div>
            </div>
          );
        }
        if (!auth.isAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: '/sign-in',
                state: { from: location },
              }}
            />
          );
        }
        return <Component {...props} />;
      }}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  auth: PropTypes.shape({
    isAuthenticated: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(PrivateRoute);
